import { render, staticRenderFns } from "./Wp_home_news_model.vue?vue&type=template&id=d7d87b9a&scoped=true&"
import script from "./Wp_home_news_model.vue?vue&type=script&lang=js&"
export * from "./Wp_home_news_model.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7d87b9a",
  null
  
)

export default component.exports